// Keep the desktop title on the same max-width and padding as PageShell's content.
export const STOCKS_HERO_BAND_CLASSNAME = "bg-surface-1 lg:min-h-[11rem]";
export const STOCKS_HERO_CONTAINER_CLASSNAME =
  "lg:mx-auto lg:min-h-[11rem] lg:w-full lg:max-w-8xl lg:px-4 lg:py-0 xl:px-4";
export const STOCKS_HERO_CONTENT_CLASSNAME =
  "max-w-[25rem] lg:max-w-[32rem] lg:[&>div]:px-0";
export const STOCKS_HERO_SUBTITLE_CLASSNAME = "max-w-[20rem] lg:max-w-[32rem]";
